<script setup>
import {computed, defineProps} from 'vue'

const props = defineProps({
  paymentsPriceDifference: {
    type: Number,
    default: 0,
  },
  totalPrice: {
    type: Number,
    default: 0,
  },
  totalSelectedPaymentsPrice: {
    type: Number,
    default: 0,
  },
  paymentsLength: {
    type: Number,
    default: 0,
  },
})

const status = computed(() => {
  if (props.paymentsPriceDifference === 0 && props.totalPrice > 0 && props.totalSelectedPaymentsPrice > 0) {
    return 'success'
  }

  if (props.paymentsLength && props.paymentsPriceDifference > 0) {
    return 'warning'
  }

  return 'info'
})
</script>

<template>
  <div class="d-flex align-items-center custom gap-3">
    <template v-if="status === 'success'">
      <i class="fa-light fa-circle-check text-success"></i>
      <span class="fs-13-px text-success">All set! Fully covered</span>
    </template>

    <template v-else-if="status === 'warning'">
      <i class="fa-light fa-circle-exclamation text-warning"></i>
      <span class="fs-13-px text-warning">Select more payments to close</span>
    </template>

    <template v-else>
      <i class="fa-light fa-circle-info"></i>
      <span class="fs-13-px">Select payments to cover amount</span>
    </template>
  </div>
</template>
